import { render, staticRenderFns } from "./wreath.vue?vue&type=template&id=fe71d4d0&scoped=true&functional=true&"
import script from "./wreath.vue?vue&type=script&lang=js&"
export * from "./wreath.vue?vue&type=script&lang=js&"
import style0 from "./wreath.vue?vue&type=style&index=0&id=fe71d4d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "fe71d4d0",
  null
  
)

export default component.exports